import { connect, MapDispatchToProps, MapStateToProps, MergeProps } from "react-redux";

import { getLocaleCode } from "@multiweb/reactCore/i18n";
import { NotificationItemId } from "@multiweb/types/contracts";
import { IAppState } from "@multiweb/types/react";
import { createMenuItemActivatedAction } from "../../actions";
import { isItemFocused, MenuFocusableItemType, MenuNavigationSectionType } from "../../navigation";
import {
    getNotificationItemActiveColorHex,
    getNotificationItemCreatedDate,
    getNotificationItemIconCode,
    getNotificationItemText,
    getNotificationItemTitle,
    isNotificationItemUnread,
} from "../../selectors";
import { MenuItemActivatedType } from "../../types";
import { createMenuItemKeyActivationHandler, createOpenableInTabItemMouseActivationHandler } from "../../utils";
import { NotificationItemComponent, NotificationItemComponentProps } from "../NotificationItemComponent";

export type NotificationItemProps = {
    notificationItemId: NotificationItemId;
};

type StateProps = Pick<
    NotificationItemComponentProps,
    "activeColorHex" | "createdDate" | "iconCode" | "isUnread" | "text" | "title" | "isFocused" | "localeCode"
>;

type DispatchProps = {
    notificationItemActivated: typeof createMenuItemActivatedAction;
};

const mapStateToProps: MapStateToProps<StateProps, NotificationItemProps, IAppState> = (state, { notificationItemId }) => ({
    activeColorHex: getNotificationItemActiveColorHex(state, notificationItemId),
    createdDate: getNotificationItemCreatedDate(state, notificationItemId),
    iconCode: getNotificationItemIconCode(state, notificationItemId),
    isUnread: isNotificationItemUnread(state, notificationItemId),
    text: getNotificationItemText(state, notificationItemId),
    title: getNotificationItemTitle(state, notificationItemId),
    isFocused: isItemFocused(state, { itemId: notificationItemId, type: MenuFocusableItemType.notificationItem, section: MenuNavigationSectionType.notifications }),
    localeCode: getLocaleCode(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, NotificationItemProps> = ({
    notificationItemActivated: createMenuItemActivatedAction,
});

const mergeProps: MergeProps<StateProps, DispatchProps, NotificationItemProps, NotificationItemComponentProps> = (
    { activeColorHex, createdDate, iconCode, isUnread, text, title, isFocused, localeCode },
    { notificationItemActivated },
    { notificationItemId },
) => ({
    activeColorHex,
    createdDate,
    iconCode,
    isUnread,
    text,
    title,
    isFocused,
    localeCode,
    onClick: createOpenableInTabItemMouseActivationHandler(notificationItemId, MenuItemActivatedType.notificationItem, MenuNavigationSectionType.notifications, notificationItemActivated),
    onKeyUp: createMenuItemKeyActivationHandler(notificationItemId, MenuItemActivatedType.notificationItem, MenuNavigationSectionType.notifications, notificationItemActivated),
});

export const NotificationItem = connect(mapStateToProps, mapDispatchToProps, mergeProps)(NotificationItemComponent);
